module.exports = __webpack_public_path__ + "static/media/Ed Tlegenov.5bfc38e7.png";